/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Subtitle_Imported_ToastInputs */



/**
* | output |
* | --- |
* | "Subtitle file imported successfully" |
*
* @param {Iframe_Remote_Subtitle_Imported_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_imported_toast = /** @type {((inputs?: Iframe_Remote_Subtitle_Imported_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Imported_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier de sous-titres importe avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertiteldatei erfolgreich importiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("File dei sottotitoli importato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл субтитров успешно импортирован.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo de subtítulos importado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕文件导入成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕ファイルが正常にインポートされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक फ़ाइल सफलतापूर्वक आयात हो गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de legendas importado com sucesso.")
	return /** @type {LocalizedString} */ ("Subtitle file imported successfully")
});